module.exports = function (data) {
    const mappedData = {
        page: {
            pageInfo: {
                sysEnv: data.sysEnv,
                variant: data.variant,
                language: data.language,
            },
        },
    };

    if (data.toUrl) { mappedData.page.pageInfo.destinationUrl = data.toUrl; }
    if (data.fromUrl) { mappedData.page.pageInfo.referringUrl = data.fromUrl; }

    return mappedData;
};



// WEBPACK FOOTER //
// ./src/configuration/analytics/page-info-dtm-mapper.js